import { LockOutlined } from '@ant-design/icons'
import { Result } from 'antd'
import React from 'react'

import { Permissions } from '@/schemas'

// 和后端统一
// prettier-ignore
export enum PERMISSIONS {
  READ = 0b0001,
  CREATE = 0b0010,
  UPDATE = 0b0100,
  DELETE = 0b1000,
  ALL = 0b1111,
}

export const PermissionOptions = [
  { label: 'Delete', value: 0b1000 },
  { label: 'Update', value: 0b0100 },
  { label: 'Create', value: 0b0010 },
  { label: 'Read', value: 0b0001 },
]

export const hasPermission = (needPermission: number, hasPermission: number) =>
  (Number(needPermission) & Number(hasPermission)) === Number(needPermission)

/**
 * 检查是否含有当前资源点内的权限
 * 1. 无权限直接返回
 * 2. 有权限 且 是要求资源点的 父集
 * 3. 有权限 且 是要求资源点的 子集
 */
export const hasPointPagePermission = (resourcePoint: string, permission: PERMISSIONS, permissions: Permissions) => {
  if (!permissions) return false
  if (permissions.find((p) => resourcePoint.startsWith(p[1]))) {
    const _permission = permissions.find((p) => resourcePoint.startsWith(p[1]))![2]
    return hasPermission(permission, _permission)
  } else if (permissions.find((p) => p[1].startsWith(resourcePoint))) {
    const _permission = permissions.find((p) => p[1].startsWith(resourcePoint))![2]
    return hasPermission(permission, _permission)
  }
}

/**
 * 获取当前资源点的权限
 * 1. 无权限直接返回
 * 2. 有权限 且 是要求资源点的 父集
 */
export const getPointPermission = (resourcePoint: string, permissions: Permissions) => {
  let canCreate = false,
    canRead = false,
    canUpdate = false,
    canDelete = false

  if (permissions && permissions.filter((p) => resourcePoint.startsWith(p[1])).length) {
    const _permissions = permissions.filter((p) => resourcePoint.startsWith(p[1]))
    canCreate = _permissions.length ? _permissions.some((p) => hasPermission(PERMISSIONS.CREATE, p[2])) : false
    canRead = _permissions.length ? _permissions.some((p) => hasPermission(PERMISSIONS.READ, p[2])) : false
    canUpdate = _permissions.length ? _permissions.some((p) => hasPermission(PERMISSIONS.UPDATE, p[2])) : false
    canDelete = _permissions.length ? _permissions.some((p) => hasPermission(PERMISSIONS.DELETE, p[2])) : false
  }

  return {
    canCreate,
    canRead,
    canUpdate,
    canDelete,
    editable: canCreate || canUpdate || canDelete, // 不进行细分时的权限
  }
}

export const LockIcon = () => {
  return <LockOutlined className='ml-2 text-red-500' />
}

export const NoPermissionPage: React.FC<{ resourcePoint: string }> = () => {
  // TODO 识别 resourcePoint selfId viewer 进行申请权限，
  return (
    <div>
      {/* {resourcePoint} */}
      <Result status='403' title='403' subTitle={'noPermission'} />
    </div>
  )
}

export const MosaicComponent: React.FC<{ content?: any }> = ({ content }) => {
  content = content ?? '********'
  const head = content.split('*').filter(Boolean)[0]
  const last = content.split('*').filter(Boolean)[1]
  const hideLength = content.match(/\*/g) ? content.match(/\*/g)!.length : 0
  return (
    <span className='break-all'>
      <span>{head}</span>
      <span className='text-transparent text-shadow-lg'>{'*'.repeat(hideLength)}</span>
      <span>{last}</span>
    </span>
  )
}
